export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'GU-IN',
        name: 'Gujarati',
        normal: '1234567890-ૃૉૌૈાીૂબહગદજડ઼ોે્િુપરકતચટંમનવલસ,.ય',
        shift: { 1: 'ઍૅ્રર્જ્ઞત્રક્ષશ્ર()ઃઋઑઔઐઆઈઊભઙઘધઝઢઞઓએઅઇઉફ', 33: 'ખથછઠ', 38: 'ઁણ', 42: 'ળશષ।' },
        alt: { 1: '૧૨૩૪૫૬૭૮૯૦', 12: 'ૄ', 45: '॥' },
        shift_alt: { 12: 'ૠ', 38: 'ૐ', 45: 'ઽ' }
    })
}
